// ─────────────────────────────────────────────────────────────────────────────
// Preferred Products Selectors
// ─────────────────────────────────────────────────────────────────────────────
// NgRx selectors for the preferredProducts store slice.
// ─────────────────────────────────────────────────────────────────────────────

import { createFeatureSelector, createSelector } from '@ngrx/store';
import { PreferredProductsState } from './preferred-products.reducers';

// ── Feature selector ─────────────────────────────────────────────────────────

export const selectPreferredProducts = createFeatureSelector<PreferredProductsState>('preferredProducts');

// ── Basic selectors ──────────────────────────────────────────────────────────

export const selectPreferredProductItems = createSelector(selectPreferredProducts, (state) => state.preferredProducts);
export const selectPreferredProductMetadata = createSelector(selectPreferredProducts, (state) => state.metadata);
export const selectPreferredProductLoading = createSelector(selectPreferredProducts, (state) => state.loading);
export const selectPreferredProductCreating = createSelector(selectPreferredProducts, (state) => state.creating);
export const selectPreferredProductUpdating = createSelector(selectPreferredProducts, (state) => state.updating);
export const selectPreferredProductDeleting = createSelector(selectPreferredProducts, (state) => state.deleting);
export const selectPreferredProductImporting = createSelector(selectPreferredProducts, (state) => state.importing);
export const selectPreferredProductKeyword = createSelector(selectPreferredProducts, (state) => state.keyword);
export const selectPreferredProductFilters = createSelector(selectPreferredProducts, (state) => state.filters);
